<template>
  <div>
    <el-dialog
      @opened="dialogOpened"
      @closed="dialogClosed"
      title="联系人修改"
      :visible.sync="dialogVisible1"
      width="800px"
    >
      <ContactsDetail
        ref="contactsDetail"
        @back="back"
        @getData="getData"
      ></ContactsDetail>
    </el-dialog>

    <vxe-grid
      ref="table"
      auto-resize
      round
      highlight-hover-row
      :data="tableData"
      :columns="tableColumn"
      :height="tableHeight - 44"
      :toolbar-config="tableToolbar"
      size="small"
      resizable
      border
    >
      <template v-slot:toolbar_form>
        <slot name="header">
          <b-button size="sm" variant="outline-success" @click="add()">
            <b-icon-plus></b-icon-plus>
            {{ $l('form_add_btn') || '新增' }}
          </b-button>
        </slot>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="row.contactStatus === 'Y' ? 'success' : 'danger'"
        >
          {{ row.contactStatusText }}
        </el-tag>
      </template>

      <template v-slot:contactFlag="{ row }">
        <el-tag
          size="mini"
          :type="row.contactDefaultFlagText === '是' ? 'success' : 'danger'"
          >{{ row.contactDefaultFlagText }}</el-tag
        >
      </template>

      <div slot="empty">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">{{ $l('INDEX.tips_no_data') || '暂无数据！' }}</p>
        </div>
      </div>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="update(row, row.scmCode)"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
          >
            <i
              class="el-icon-delete tool-btn"
              @click="del(row)"
              v-show="row.contactStatus === 'Y'"
            ></i>
          </el-tooltip>
        </div>
      </template>
    </vxe-grid>
    <pagination
      :current-page="page.curPage"
      :page-size="page.pageSize"
      :page-total="page.pageTotal"
      size="small"
      align="right"
      slot="pager"
      @change="handlePaginationChange"
    />
  </div>
</template>
<script>
import ContactsDetail from './detail/contactsDetail'
import TableAutoHeight from '@/mixins/table-auto-height'
export default {
  mixins: [TableAutoHeight],
  props: {
    scmCode: {
      type: String,
      default: () => '',
    },
  },
  components: {
    ContactsDetail,
  },
  data() {
    return {
      dialogVisible1: false,
      tableData: [],
      formData: {},
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.getData(),
        },
        zoom: true,
        custom: true,
      },
      tableColumn: [
        {
          field: 'seq',
          width: 50,
          align: 'center',
          type: 'seq',
          fixed: 'left',
        },
        {
          field: 'col-opt',
          title: this.$l('table_label_operation') || '操作',
          align: 'center',
          width: 100,
          fixed: 'left',
          slots: {
            default: 'opt',
          },
        },
        {
          headerAlign: 'center',
          field: 'contactName',
          minWidth: 150,
          title: this.$l('conact_table_label_name') || '姓名',
        },
        {
          headerAlign: 'center',
          field: 'contactJob',
          minWidth: 150,
          title: this.$l('conact_table_label_position') || '职位',
        },
        {
          field: 'contactMobile',
          minWidth: 150,
          title: this.$l('conact_table_label_mobile_phone') || '移动电话',
          headerAlign: 'center',
        },
        {
          field: 'contactPhone',
          minWidth: 150,
          title: this.$l('conact_table_label_office_phone') || '办公电话',
          headerAlign: 'center',
        },
        {
          field: 'contactEmail',
          minWidth: 200,
          title: this.$l('conact_table_label_email') || '邮箱',
          headerAlign: 'center',
        },
        {
          field: 'contactDefaultFlag',
          width: 100,
          title: this.$l('conact_table_label_default_contact') || '默认联系人',
          align: 'center',
          slots: { default: 'contactFlag' },
        },
        {
          field: 'contactStatus',
          width: 80,
          title: this.$l('conact_table_label_status') || '状态',
          align: 'center',
          slots: { default: 'status' },
        },
      ],
      loading: false,
      page: {
        curPage: 1,
        pageSize: 5,
        pageTotal: 0,
      },
    }
  },
  watch: {
    scmCode: {
      handler(scmCode) {
        if (scmCode !== '') {
          this.getData()
        }
      },
      immediate: true,
    },
  },
  methods: {
    // 分页查询
    handlePaginationChange(val) {
      this.page = {
        curPage: val.current,
        pageSize: val.size,
        pageTotal: val.total,
      }
      this.$nextTick(() => {
        this.getData()
      })
    },
    getData() {
      if (this.scmCode === '') return
      this.loading = true
      this.$api
        .scmInfoContactsListApi({ scmCode: this.scmCode, ...this.page })
        .then((res) => {
          this.loading = false
          this.page.pageTotal = res.body.count
          this.tableData = res.body.data
        })
    },
    dialogOpened() {
      this.$refs.contactsDetail.init(this.formData)
    },
    dialogClosed() {
      this.getData()
    },
    add() {
      this.formData = {
        type: 'add',
        scmCode: this.scmCode,
        contactNameCardUrl1: '',
        contactNameCardUrl2: '',
        contactDefaultFlag: 'N',
      }
      this.dialogVisible1 = true
    },
    update(row) {
      let strRow = JSON.stringify(row)
      this.formData = JSON.parse(strRow)
      this.formData.type = 'update'
      this.dialogVisible1 = true
    },
    save() {
      this.dialogVisible1 = false
    },
    del(row) {
      this.$confirm('确定要删除“' + row.contactName + '”吗？', '提示')
        .then(() => {
          this.$api
            .scmInfoContactsUpdateStatusApi({
              scmCode: row.scmCode,
              seqno: row.seqno,
            })
            .then(() => {
              this.$message({
                type: 'success',
                message: '删除成功 ',
              })
              this.getData()
            })
        })
        .catch(() => {})
    },
    back() {
      this.dialogVisible1 = false
    },
  },
}
</script>
